import { useEffect } from 'react';
import { useBlocker, type BlockerFunction } from 'react-router-dom';
import { confirmPopup } from 'components/Popups/Confirm';

/** React confirmation for in-app navigation; keeps the pending destination when confirmed. */
export function useUnsavedChangesPrompt({ when, message }: { when: boolean | BlockerFunction; message: string }): void {
    const blocker = useBlocker(when);

    useEffect(() => {
        if (blocker.state !== 'blocked') return;
        const controller = new AbortController();
        void confirmPopup({
            title: 'Modifications non enregistrées',
            message,
            confirmLabel: 'Quitter sans enregistrer',
            isDestructive: true,
            cancelLabel: 'Rester sur la page',
            signal: controller.signal,
        }).then((confirmed) => {
            if (controller.signal.aborted) return;
            if (confirmed) blocker.proceed();
            else blocker.reset();
        });
        return () => controller.abort();
    }, [blocker, message]);
}
